import { render, staticRenderFns } from "./CatalogTypes.vue?vue&type=template&id=d3627a34&scoped=true&"
import script from "./CatalogTypes.vue?vue&type=script&lang=js&"
export * from "./CatalogTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3627a34",
  null
  
)

export default component.exports